import { createTheme } from "@mui/material";

export const Theme = (mode) => {
  return createTheme({
    palette: {
      mode,

      ...(mode === "light"
        ? {
            primary: { main: "#11d452" },
            secondary: { main: "rgba(17, 212, 82, 0.5)" },
            primaryTransparent: { main: "rgba(0,153,41,0.5)" },
            paperTransparent: { main: "rgba(255, 255, 255, 0.8)" },
            toggleDarkMode: { main: "#000" },
            buttons: { main: "#000" },
          }
        : {
            primary: { main: "#11d452" },
            secondary: { main: "rgba(17, 212, 82, 0.5)" },
            primaryTransparent: { main: "rgba(82, 253, 0, 0.9)" },
            paperTransparent: { main: "rgba(18, 18, 18, 0.8)" },
            toggleDarkMode: { main: "#fff" },
            buttons: { main: "#fff" },
          }),
    },

    components: {
      MuiBottomNavigation: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent",
          },
        },
      },

      MuiBottomNavigationAction: {
        styleOverrides: {
          label: {
            fontSize: "0.8rem",
            textTransform: "uppercase",
          },
        },
      },
    },
    typography: {
      allVariants: {
        fontFamily: "Roboto",
      },
      h3: { fontFamily: "", fontWeight: "bold" },
      h4: { fontFamily: "", fontWeight: "bold" },
      h5: { fontFamily: "", fontWeight: "bold" },
      h6: { fontFamily: "Orbitron", fontWeight: "bold" },
    },
  });
};
